(() => {
  const initialize = (scope = document) => {
    const header = scope.querySelector('[data-ch-header]');
    if (header && !header.dataset.chReady) {
      header.dataset.chReady = 'true';
      const toggle = header.querySelector('[data-ch-menu-toggle]');
      const menu = header.querySelector('#ch-category-menu');
      const backdrop = header.querySelector('[data-ch-backdrop]');
      const tabs = [...menu.querySelectorAll('[role="tab"]')];
      const hoverPointer = matchMedia('(hover: hover) and (pointer: fine)');
      let hoverTimer;
      const cancelHover = () => {
        clearTimeout(hoverTimer);
        hoverTimer = undefined;
      };
      let previousOverflow = '';
      let openedByHover = false;
      let lastMenuClose = 0;
      const select = (tab) => {
        cancelHover();
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          menu.querySelector(`#${item.getAttribute('aria-controls')}`).hidden = !active;
        });
      };
      const close = (restore = true) => {
        cancelHover();
        if (menu.hidden) return;
        menu.hidden = backdrop.hidden = true;
        openedByHover = false;
        lastMenuClose = Date.now();
        toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = previousOverflow;
        if (restore) toggle.focus();
      };
      const open = (focusMenu = true) => {
        cancelHover();
        if (menu.hidden) {
          previousOverflow = document.body.style.overflow;
          menu.hidden = backdrop.hidden = false;
          toggle.setAttribute('aria-expanded', 'true');
          document.body.style.overflow = 'hidden';
        }
        if (focusMenu) (tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || menu.querySelector('button')).focus();
      };
      toggle.addEventListener('pointerenter', (event) => {
        if (!hoverPointer.matches || event.pointerType === 'touch' || !menu.hidden || Date.now() - lastMenuClose < 250) return;
        openedByHover = true;
        open(false);
      });
      toggle.addEventListener('click', () => {
        cancelHover();
        // A click following hover enters the already-open menu instead of closing it.
        if (!menu.hidden && !openedByHover) { close(); return; }
        openedByHover = false;
        open();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !menu.hidden && !menu.contains(event.target)) {
          event.preventDefault();
          close();
        }
      });
      menu.querySelector('[data-ch-menu-close]').addEventListener('click', () => close());
      backdrop.addEventListener('click', () => close());
      tabs.forEach((tab, index) => {
        tab.addEventListener('pointerenter', (event) => {
          cancelHover();
          if (menu.hidden || !hoverPointer.matches || event.pointerType === 'touch') return;
          hoverTimer = setTimeout(() => {
            if (!menu.hidden && hoverPointer.matches) select(tab);
          }, 150);
        });
        tab.addEventListener('pointerleave', cancelHover);
        tab.addEventListener('pointercancel', cancelHover);
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(tabs[next]); tabs[next].focus(); }
        });
      });
      menu.addEventListener('keydown', (event) => {
        cancelHover();
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key !== 'Tab') return;
        const focusable = [...menu.querySelectorAll('a[href],button,[tabindex="0"]')].filter((item) => item.getClientRects().length && item.tabIndex !== -1);
        const first = focusable[0];
        const last = focusable.at(-1);
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(header)) close(false);
      });
    }
    const collection = scope.querySelector('[data-ch-collection]');
    if (!collection || collection.dataset.chReady) return;
    collection.dataset.chReady = 'true';
    const typeScroll = collection.querySelector('[data-ch-type-scroll]');
    if (typeScroll) {
      const rail = typeScroll.querySelector('.ch-type-links');
      const previous = typeScroll.querySelector('[data-ch-type-prev]');
      const next = typeScroll.querySelector('[data-ch-type-next]');
      const updateArrows = () => {
        const overflow = rail.scrollWidth > rail.clientWidth + 1;
        typeScroll.dataset.overflow = String(overflow);
        previous.hidden = next.hidden = !overflow;
        previous.disabled = rail.scrollLeft <= 1;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 1;
      };
      const scrollRail = (direction) => rail.scrollBy({
        left: direction * Math.max(160, rail.clientWidth * 0.7),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      previous.addEventListener('click', () => scrollRail(-1));
      next.addEventListener('click', () => scrollRail(1));
      rail.addEventListener('scroll', updateArrows, { passive: true });
      const observer = new ResizeObserver(updateArrows);
      observer.observe(rail);
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(collection)) observer.disconnect();
      });
      document.fonts.ready.then(updateArrows);
      updateArrows();
    }
    const messages = JSON.parse(collection.querySelector('[data-ch-messages]').textContent);
    const filterForm = collection.querySelector('[data-ch-filters]');
    const search = collection.querySelector('[data-ch-collection-search]');
    const queryField = collection.querySelector('[data-ch-query-field]');
    const typeField = collection.querySelector('[data-ch-type-field]');
    const clearType = collection.querySelector('[data-ch-clear-type]');
    const grid = collection.querySelector('[data-ch-grid]');
    const status = collection.querySelector('[data-ch-result-count]');
    const empty = collection.querySelector('[data-ch-empty]');
    const pagination = collection.querySelector('[data-ch-pagination]');
    const catalog = collection.querySelector('[data-pages]');
    const originalMarkup = grid.innerHTML;
    const originalCount = status.textContent;
    let searchController;
    let searchTimer;
    let searchSequence = 0;
    let lastQuery = '';
    const pendingVariants = new Set();
    const uncertainVariants = new Set();
    const syncCartState = () => {
      grid.querySelectorAll('[data-ch-add]').forEach((form) => {
        const id = new FormData(form).get('id');
        const button = form.querySelector('button[type="submit"]');
        button.disabled = pendingVariants.has(id);
        if (uncertainVariants.has(id)) form.querySelector('[role="status"]').textContent = messages.cartUncertain;
      });
    };
    const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
    if (previewTheme) {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = 'preview_theme_id'; input.value = previewTheme;
      filterForm.append(input);
    }
    if (matchMedia('(max-width: 900px)').matches) collection.querySelector('.ch-filters__details').open = false;
    collection.querySelector('[data-ch-sort]').addEventListener('change', () => filterForm.requestSubmit());
    const runSearch = async (updateHistory = true) => {
      const query = search.value.trim();
      const equipmentType = new URL(location.href).searchParams.get('ch_type') || '';
      // Shopify facet counts omit the client-side type/text intersection.
      collection.querySelectorAll('[data-ch-facet-count]').forEach((count) => {
        count.hidden = Boolean(query || equipmentType);
      });
      queryField.value = query;
      typeField.value = equipmentType;
      clearType.hidden = !equipmentType;
      clearType.querySelector('[data-ch-type-label]').textContent = equipmentType;
      const clearTypeUrl = new URL(location.href);
      clearTypeUrl.searchParams.delete('ch_type');
      clearTypeUrl.searchParams.delete('page');
      clearType.href = clearTypeUrl;
      collection.querySelectorAll('[data-ch-type-link]').forEach((link) => {
        if (new URL(link.href).searchParams.get('ch_type') === equipmentType) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      searchController?.abort();
      const sequence = ++searchSequence;
      if (updateHistory) {
        const url = new URL(location.href);
        if (query) url.searchParams.set('ch_q', query); else url.searchParams.delete('ch_q');
        if (query !== lastQuery) history.pushState({ chSearch: true }, '', url);
      }
      lastQuery = query;
      grid.innerHTML = originalMarkup;
      syncCartState();
      grid.removeAttribute('aria-busy');
      if (!query && !equipmentType) {
        status.textContent = originalCount;
        pagination.hidden = false;
        empty.hidden = !!grid.children.length;
        return;
      }
      const words = query.toLocaleLowerCase().split(/\s+/).filter(Boolean);
      const filterCards = () => {
        let count = 0;
        grid.querySelectorAll('[data-ch-product]').forEach((card) => {
          card.hidden = (equipmentType && card.dataset.productType !== equipmentType) || !words.every((word) => card.dataset.searchText.toLocaleLowerCase().includes(word));
          if (!card.hidden) count++;
        });
        return count;
      };
      filterCards();
      pagination.hidden = true;
      empty.hidden = true;
      status.textContent = messages.searching;
      grid.setAttribute('aria-busy', 'true');
      searchController = new AbortController();
      const controller = searchController;
      const timeout = setTimeout(() => controller.abort(), 30000);
      try {
        const currentPage = Number(catalog.dataset.currentPage);
        for (let page = 1; page <= Number(catalog.dataset.pages); page++) {
          if (page === currentPage) continue;
          const url = new URL(location.href);
          url.searchParams.delete('ch_q');
          url.searchParams.delete('ch_type');
          url.searchParams.set('section_id', collection.dataset.sectionId);
          url.searchParams.set('page', String(page));
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Search page unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const otherGrid = html.querySelector('[data-ch-grid]');
          if (!otherGrid) throw new Error('Search page incomplete');
          if (sequence !== searchSequence) return;
          otherGrid.querySelectorAll('[data-ch-product]').forEach((card) => grid.append(document.importNode(card, true)));
          syncCartState();
          filterCards();
        }
        if (sequence !== searchSequence) return;
        const count = filterCards();
        status.textContent = `${count} ${messages.matches}${equipmentType ? ` · ${equipmentType}` : ''}`;
        empty.hidden = count !== 0;
      } catch (error) {
        if (sequence !== searchSequence) return;
        grid.innerHTML = originalMarkup;
        syncCartState();
        if (equipmentType) grid.querySelectorAll('[data-ch-product]').forEach((card) => { card.hidden = true; });
        status.textContent = messages.searchError;
        pagination.hidden = !!equipmentType;
        empty.hidden = !!grid.children.length;
      } finally {
        clearTimeout(timeout);
        if (sequence === searchSequence) grid.removeAttribute('aria-busy');
      }
    };
    search.addEventListener('input', () => { clearTimeout(searchTimer); searchTimer = setTimeout(() => runSearch(), 350); });
    search.addEventListener('keydown', (event) => { if (event.key === 'Enter') { event.preventDefault(); clearTimeout(searchTimer); runSearch(); } });
    window.addEventListener('popstate', () => {
      clearTimeout(searchTimer);
      search.value = new URL(location.href).searchParams.get('ch_q') || '';
      runSearch(false);
    });
    filterForm.addEventListener('submit', () => { queryField.value = search.value.trim(); });
    collection.querySelectorAll('.ch-active-filters a').forEach((link) => link.addEventListener('click', () => {
      const url = new URL(link.href);
      if (search.value.trim()) url.searchParams.set('ch_q', search.value.trim());
      if (typeField.value && !link.matches('[data-ch-clear-type]')) url.searchParams.set('ch_type', typeField.value);
      link.href = url;
    }));
    search.value = new URL(location.href).searchParams.get('ch_q') || '';
    runSearch(false);
    collection.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-ch-add]');
      if (!form) return;
      event.preventDefault();
      const data = new FormData(form);
      const id = data.get('id');
      if (pendingVariants.has(id)) return;
      pendingVariants.add(id);
      const button = form.querySelector('button[type="submit"]');
      const message = form.querySelector('[role="status"]');
      const originalLabel = button.textContent;
      button.disabled = true;
      button.textContent = messages.adding;
      message.textContent = '';
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      let uncertain = false;
      try {
        const response = await fetch(`${window.routes.cartAddUrl}.js`, { method: 'POST', body: data, credentials: 'same-origin', signal: controller.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) {
          const failure = await response.json().catch(() => ({}));
          message.textContent = typeof failure.description === 'string' ? failure.description : messages.cartError;
          return;
        }
        message.textContent = messages.added;
        if (window.theme.cartType === 'page') { location.assign(window.routes.cartUrl); return; }
        document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { button, variant: null, quantity: Number(data.get('quantity')), productAdded: true } }));
      } catch (error) {
        uncertain = true;
        uncertainVariants.add(id);
        message.textContent = messages.cartUncertain;
        const cartLink = document.createElement('a');
        cartLink.href = window.routes.cartUrl;
        cartLink.textContent = ` ${window.languages?.cartViewCart || 'View cart'} →`;
        message.append(cartLink);
      } finally {
        clearTimeout(timeout);
        button.textContent = originalLabel;
        if (!uncertain) { button.disabled = false; pendingVariants.delete(id); }
        syncCartState();
      }
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
